import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CarrierResponse, LoadingListItemRequest, LoadingListItemsRequest, LoadingListItemsResponse, LoadingListItemStatus, LoadingListManagementRequest, LoadingListRequest, LoadingListService, LoadingListType, TourGroupsResponse } from '../../../services/loading-list.service';
import { TripService } from '../../../services/trip.service';
import { TripAttachRequest, TripInfoResponse } from '../../../interfaces/trip.interfaces';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, LocationStrategy } from '@angular/common';
import { Warehouse } from '../../../interfaces/Warehouses.interfaces';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoadingLists } from '../../../interfaces/LoadingLists.interfaces';
import { LoadingListStatus } from '../loading-list.component';
import { Carriers } from '../../../interfaces/Carriers.interfaces';
import { ClientsBrands } from '../../../services/routing.service';
import { finalize } from 'rxjs';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export interface NewLoadingListDialogData {
  mode: 'CREATE' | 'EDIT';
  warehouses: Warehouse[];
  loadingList: LoadingLists;
  carriers: Carriers[];
  tourGroups: string;
  myWarehouseCode: string;
  readOnly?: boolean;
  
  linkedTripCode?: string | null;
  showAllItemDates?: boolean;
}

export interface LoadingListTractionInfo {
  tripPointCarrierCode: string;
  tripPointTractorPlateNo: string | null;
  tripPointDriverName: string;
  tripPointLockCode: string | null;
}

/** Rotta della pagina "Gestione Colli TP" (overview-warehouse). */
const OVERVIEW_WAREHOUSE_ROUTE = '/overview-warehouse';

type UiValidItem = LoadingListItemsResponse & {
  /** Collo aggiunto al borderò all'arrivo (LOADING_LIST_ITEM_IS_LOADED_ON_DEPARTURE = 'N'). */
  addedOnArrival?: boolean;
  /** Magazzino di arrivo del collo. */
  warehouseToCode?: string | null;
  /** Bolla del collo e invio al vettore (COM_WAYBILLS 'SENT_WAYBILL_TO_CARRIER'). */
  waybillCode?: string | null;
  waybillSentToCarrier?: boolean;
  waybillCarriersSentAt?: string | null;
  waybillCarriersSentEmails?: string | null;
  /** Collo aggiunto con l'import Excel (non ancora salvato). */
  importedFromExcel?: boolean;
  selected: boolean;
  weightKgNum: number;   // normalizzati
  volumeM3Num: number;
  originalIndex: number;
};

/** Esito di un barcode dell'import Excel restituito dal backend. */
interface ImportBarcodeRowResponse {
  barcode: string;
  severity: 'OK' | 'WARNING' | 'ERROR';
  checks: string[];
  otherLoadingListCode?: string | null;
  otherTripCode?: string | null;
  parcelTourGroupNames?: string | null;
  item?: LoadingListItemsResponse & { warehouseToCode?: string | null; waybillCode?: string | null } | null;
}

interface ImportMessage {
  text: string;
  level: 'ok' | 'info' | 'warning' | 'error';
}

/** Riga dell'anteprima import (step "colli trovati"). */
interface ImportPreviewRow extends ImportBarcodeRowResponse {
  level: 'ok' | 'warning' | 'error';
  messages: ImportMessage[];
  selectable: boolean;
  selected: boolean;
  alreadyInList: boolean;
}

/** Massimo numero di barcode per import (tutela backend e UI). */
const IMPORT_MAX_BARCODES = 2000;
/** Durata minima dell'animazione di caricamento, per renderla percepibile. */
const IMPORT_MIN_LOADING_MS = 900;

@Component({
  selector: 'app-new-loading-list-dialog',
  standalone: true,
  templateUrl: './new-loading-list-dialog.component.html',
  styleUrls: ['./new-loading-list-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgSelectModule
  ]
})
export class NewLoadingListDialogComponent implements OnInit {
  form!: FormGroup;

  tourGroups: TourGroupsResponse[] = [];
  carriers: CarrierResponse[] = [];

  loadingTours = false;
  loadingCarriers = false;

  clientsBrands: ClientsBrands[] = [];

  tourGroupNames: string = '';

  loadingListType: 'ARRIVAL' | 'DEPARTURE' = 'DEPARTURE';

  mode: 'CREATE' | 'EDIT' = 'CREATE';

  readOnly = false;

  loadingListStatus: string | undefined = '';

  loadingItemsSpinner: boolean = false;

  isExtraVisible: boolean = false;

  loadingListCode: string = '';

  itemsCountOriginal: number | null = null;

  linkMode: 'NONE' | 'INPUT' | 'ACTIVE' = 'NONE';
  linkCodeValue: string = '';
  linkFromTrip = false;

  resolvingLink = false;
  linkResolveError: string | null = null;

  linkedTripId: number | null = null;
  linkedTripCode: string | null = null;
  linkedTripCarrierCode: string | null = null;
  linkedTripCarrierName: string | null = null;

  pendingTripLink: TripInfoResponse | null = null;

  linkedTripCarrierMismatch = false;

  tripLinkForced = false;

  carrierMismatchNeedsDecision = false;


possibleWarehouses: string[] = [];
selectedWarehouseCode: string | null = null;
editingLoadingListId: number | null = null;

showFilters = false;
selectedRegion: string | null = null;
onlyUrgent = false;
onlyAddedOnArrival = false;
onlyWaybillNotSent = false;
filterParcelDate: string | null = null;
filterDeliveryDate: string | null = null;

availableRegions: (string | undefined)[] = [];

isDeclaringUnloadingEnd = false;
private itemsSnapshot: Array<{ selected: boolean; status: LoadingListItemStatus }> = [];

  constructor(
    private fb: FormBuilder,
    private loadingListService: LoadingListService,
    private tripService: TripService,
    private dialogRef: MatDialogRef<NewLoadingListDialogComponent>,
    private router: Router,
    private locationStrategy: LocationStrategy,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: NewLoadingListDialogData
  ) {}

  ngOnInit(): void {
  const warehouses = this.data.warehouses ?? [];
  const preselected = warehouses.length === 1 ? warehouses[0].warehouseCode : null;

  this.mode = this.data?.mode ?? 'CREATE';
  this.readOnly = this.data?.readOnly === true;

  this.form = this.fb.group({
    warehouseCode: [preselected, Validators.required],
    extra: [false],
    tourGroupIds: this.fb.array([this.createTourGroupControl()]),
    carrierCode: [null, Validators.required],
    plate: ['', [Validators.required]]
  });

  if (this.mode === 'CREATE' && this.data?.linkedTripCode) {
    this.linkFromTrip = true;
    this.linkCodeValue = this.data.linkedTripCode;
    this.linkMode = 'ACTIVE';
    this.resolvePrefilledTripLink(this.data.linkedTripCode);
  }

  if (preselected) this.loadTourGroups(preselected);

  this.form.get('warehouseCode')!.valueChanges.subscribe((code) => {
    this.onWarehouseChanged(code);
  });

  this.form.get('extra')!.valueChanges.subscribe(() => {
    this.onExtraChanged();
  });

  this.tourGroupIdsArray.valueChanges.subscribe(() => this.refreshTourGroupOptions());
  this.refreshTourGroupOptions();

  if (this.mode === 'EDIT') {

    const myWh = (this.data?.myWarehouseCode || '').toString().trim().toLowerCase();
    const llWh = (this.data?.loadingList?.loadingListWarehouseCode || '').toString().trim().toLowerCase();

    this.loadingListType = this.readOnly || (myWh && llWh && myWh === llWh) ? 'DEPARTURE' : 'ARRIVAL';

    this.itemsCountOriginal = this.data?.loadingList?.loadingListItemsCount ?? null;

    if (this.loadingListType === 'ARRIVAL') {
      this.selectedWarehouseCode = this.data?.myWarehouseCode ?? null;
    }

    const ll = this.data.loadingList;
    this.tourGroupNames = this.data.tourGroups;

    this.loadingListStatus = ll.loadingListStatus;

    this.loadingListCode = ll.loadingListCode;

    if (ll.loadingListTripId || ll.loadingListTripCode) {
      this.linkMode = 'ACTIVE';
      this.linkedTripId = ll.loadingListTripId ?? null;
      this.linkedTripCode = ll.loadingListTripCode ?? null;
      this.linkCodeValue = ll.loadingListTripCode ?? '';
      this.linkedTripCarrierCode = ll.loadingListCarrierCode ?? null;
      this.linkedTripCarrierName = this.data.carriers?.find(c => c.carrierCode === ll.loadingListCarrierCode)?.carrierName ?? null;
    } else if (this.data?.linkedTripCode) {
      this.linkMode = 'ACTIVE';
      this.linkedTripCode = this.data.linkedTripCode;
      this.linkCodeValue = this.data.linkedTripCode;
      this.linkedTripCarrierCode = ll.loadingListCarrierCode ?? null;
      this.linkedTripCarrierName = this.data.carriers?.find(c => c.carrierCode === ll.loadingListCarrierCode)?.carrierName ?? null;
    }

    this.step = 2;

    //this.loadTourGroups(ll.loadingListWarehouseCode!);

    // this.loadingListType = this.isArrivedStatus(ll.loadingListStatus)
    // ? 'ARRIVAL'
    // : 'DEPARTURE';

    this.form.patchValue({
      warehouseCode: ll.loadingListWarehouseCode,
      carrierCode: ll.loadingListCarrierCode,
      plate: ll.loadingListPlateNo
    }, { emitEvent: false });

    this.loadItemsForEdit(ll.loadingListId);
  }
}

loadItemsForEdit(loadingListId: number): void {
  this.editingLoadingListId = loadingListId;

  this.loadPossibleWarehouses(loadingListId);

  // this.loadingListService.getLoadingListItems(loadingListId).subscribe({
  //   next: (items) => {
  //     const selStatus = this.selectedStatusForType();

  //     this.validItems = (items ?? []).map((x: any) => {
  //       const status: LoadingListItemStatus = x.loadingListItemStatus ?? 'PENDING';

  //       return {
  //         ...x,
  //         selected: status === selStatus,
  //         weightKgNum: Number(x.weightKg ?? 0),
  //         volumeM3Num: Number(x.volumeM3 ?? 0),
  //         loadingListItemStatus: status
  //       };
  //     });

  //   },
  //   error: (err) => console.error(err)
  // });
}

  get llStatus(): string {
    return (this.data?.loadingList?.loadingListStatus || '').toString().toUpperCase();
  }

  isDraft(): boolean { return this.llStatus === 'DRAFT'; }
  isPrepared(): boolean { return this.llStatus === 'PREPARED'; }
  isArrived(): boolean { return this.llStatus === 'ARRIVED' || this.llStatus === 'ARRIVING'; }
  isClosed(): boolean { return this.llStatus === 'CLOSED'; }

  getStatusLabel(): string {
    const status = (this.data?.loadingList?.loadingListStatus || '').toString().toUpperCase();

    switch (status) {
      case 'DELETED':   return LoadingListStatus.DELETED;
      case 'DRAFT':     return LoadingListStatus.DRAFT;
      case 'CLOSED':    return LoadingListStatus.CLOSED;
      case 'PREPARED':  return LoadingListStatus.PREPARED;
      case 'ARRIVED':   return LoadingListStatus.ARRIVED;
      case 'ARRIVING':   return LoadingListStatus.ARRIVING;
      default:          return status || '-';
    }
  }


  get tourGroupIdsArray(): FormArray<FormControl<number | null>> {
    return this.form.get('tourGroupIds') as FormArray<FormControl<number | null>>;
  }

  private createTourGroupControl(): FormControl<number | null> {
    return this.fb.control<number | null>(null, Validators.required);
  }

  get selectedTourGroupNames(): string {
    if (!this.form) return '';

    const ids = this.form.get('tourGroupIds')?.value as (number | null)[];

    return ids
      .filter((id): id is number => id !== null)
      .map(id => this.tourGroups.find(t => t.tourRoutingGroupId === id)?.tourRoutingGroupName)
      .filter((name): name is string => !!name)
      .join(', ');
  }


  loadTourGroups(warehouseCode: string): void {
    this.loadingTours = true;
    this.loadingListService.searchTourGroups({ warehouseCode }).subscribe({
      next: (groups) => {
        this.tourGroups = groups ?? [];
        this.refreshTourGroupOptions();
        this.setSingleTourGroupIfNeeded();
        this.onTourGroupChanged();
      },
      error: (err) => {
        console.error(err);
        this.loadingTours = false;
      },
      complete: () => (this.loadingTours = false)
    });
  }


    private onWarehouseChanged(warehouseCode: string | null): void {
        const warehouse = this.data.warehouses.find(w => w.warehouseCode === warehouseCode);
        this.isExtraVisible = !!warehouse && warehouse.warehouseType !== 'TP';
        this.tourGroupIdsArray.clear();
        this.tourGroupIdsArray.push(this.createTourGroupControl());
        this.resetCarrierAndCarriersList();
        this.tourGroups = [];
        this.refreshTourGroupOptions();
        if (!warehouseCode) return;
        this.loadTourGroups(warehouseCode);
    }



  addTourGroup(): void {
    if (!this.form.get('warehouseCode')?.value) return;

    this.tourGroupIdsArray.push(this.createTourGroupControl());
    this.resetCarrierAndCarriersList();
  }

  removeTourGroup(index: number): void {
    if (this.tourGroupIdsArray.length <= 1) return;

    this.tourGroupIdsArray.removeAt(index);

    this.resetCarrierAndCarriersList();
    this.refreshCarriersFromSelectedGroups();
  }


  onTourGroupChanged(): void {
    this.resetCarrierAndCarriersList();
    this.refreshCarriersFromSelectedGroups();
  }


  private resetCarrierAndCarriersList(): void {
    this.form.get('carrierCode')?.setValue(null);
    this.carriers = [];
  }

  get isCarrierLockedByTrip(): boolean {
    return this.linkMode === 'ACTIVE' && !!this.linkedTripCarrierCode;
  }

    private refreshCarriersFromSelectedGroups(): void {
        const extra = !!this.form.get('extra')?.value;

        const ids = this.getSelectedTourGroupIds();

        // se extra=false e non ho gruppi -> non chiamare
        if (!extra && ids.length === 0) return;

        this.loadingCarriers = true;
        this.loadingListService.searchTourGroupCarriers({
            tourRoutingGroupId: ids,
            extra: extra
        }).subscribe({
            next: (res) => {
            this.carriers = res?.carriers ?? [];
            this.applyCarrierSelection(extra);
            },
            error: () => {
            this.loadingCarriers = false;
            this.carriers = [];
            this.form.get('carrierCode')?.setValue(null);
            this.linkedTripCarrierMismatch = this.isCarrierLockedByTrip;
            },
            complete: () => (this.loadingCarriers = false)
        });
    }

    private applyCarrierSelection(extra: boolean): void {
      if (this.isCarrierLockedByTrip) {
        const tripCarrierInList = this.carriers.find(c => c.carrierCode === this.linkedTripCarrierCode);

        if (tripCarrierInList) {
          this.linkedTripCarrierMismatch = false;
          this.carrierMismatchNeedsDecision = false;
          this.form.get('carrierCode')?.setValue(this.linkedTripCarrierCode);
        } else if (extra || this.tripLinkForced || !this.canEditLink) {
          this.applyForcedTripCarrier();
        } else {
          this.carriers = [];
          this.form.get('carrierCode')?.setValue(null);
          this.linkedTripCarrierMismatch = false;
          this.carrierMismatchNeedsDecision = true;
        }
        return;
      }

      this.linkedTripCarrierMismatch = false;
      this.carrierMismatchNeedsDecision = false;
      const defaultCarrier = this.carriers.find(c => c.defaultCarrier);
      if (defaultCarrier) {
        this.form.get('carrierCode')?.setValue(defaultCarrier.carrierCode);
      } else if (this.carriers.length === 1) {
        this.form.get('carrierCode')?.setValue(this.carriers[0].carrierCode);
      } else {
        this.form.get('carrierCode')?.setValue(null);
      }
    }

    confirmForceCarrierFromMismatch(): void {
      this.tripLinkForced = true;
      this.carrierMismatchNeedsDecision = false;
      this.applyForcedTripCarrier();
    }

    removeLinkFromMismatch(): void {
      this.carrierMismatchNeedsDecision = false;
      this.removeLink();
    }


  private getSelectedTourGroupIds(): number[] {
    const ids = this.tourGroupIdsArray.controls
      .map(c => c.value)
      .filter((v): v is number => v !== null);

    return Array.from(new Set(ids));
  }

  /**
   * Opzioni per ogni riga tour group, in cache: ng-select non deve ricevere un array nuovo
   * a ogni change detection (perderebbe evidenziazione/ricerca).
   */
  tourGroupOptions: TourGroupsResponse[][] = [];

  refreshTourGroupOptions(): void {
    this.tourGroupOptions = this.tourGroupIdsArray.controls.map((_, i) => this.getAvailableTourGroupsForIndex(i));
  }

  searchTourGroupFn = (term: string, item: any): boolean => {
    return this.normalizeSearch(item?.tourRoutingGroupName).includes(this.normalizeSearch(term));
  };

  getAvailableTourGroupsForIndex(index: number): TourGroupsResponse[] {
    const selected = this.tourGroupIdsArray.controls
      .map((c, i) => (i === index ? null : c.value))
      .filter((v): v is number => v !== null);

    return this.tourGroups.filter(g => !selected.includes(g.tourRoutingGroupId));
  }

  onPlateInput(): void {
    const ctrl = this.form.get('plate');
    if (!ctrl) return;

    const raw = (ctrl.value ?? '').toString();
    const normalized = raw.replace(/\s|-/g, '').toUpperCase();
    if (normalized !== raw) ctrl.setValue(normalized, { emitEvent: false });
  }

  italianPlateValidator(control: FormControl): { [key: string]: any } | null {
    const value = (control.value ?? '').toString().trim().replace(/\s|-/g, '').toUpperCase();
    if (!value) return null;

    const current = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/;

    return current.test(value) ? null : { italianPlate: true };
  }

  private buildSelectedToursRequest(): { tourRoutingGroupId: number; tourRoutingGroupName: string }[] {
    const ids = this.getSelectedTourGroupIds();

    return ids
      .map(id => {
        const tg = this.tourGroups.find(t => t.tourRoutingGroupId === id);
        return tg
          ? { tourRoutingGroupId: tg.tourRoutingGroupId, tourRoutingGroupName: tg.tourRoutingGroupName }
          : null;
      })
      .filter((x): x is { tourRoutingGroupId: number; tourRoutingGroupName: string } => x !== null);
  }

  private buildSelectedCarrierRequest():
    | { carrierCode: string; carrierName: string }
    | null {
    const code = this.form.value.carrierCode as string | null;
    if (!code) return null;

    const c = this.carriers.find(x => x.carrierCode === code);
    return c ? { carrierCode: c.carrierCode, carrierName: c.carrierName } : null;
  }


  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const selectedTours = this.buildSelectedToursRequest();
    const selectedCarrier = this.buildSelectedCarrierRequest();

    if (!selectedCarrier) {
      this.form.get('carrierCode')?.setErrors({ required: true });
      return;
    }

    const stored = localStorage.getItem('userFunctions');
    this.clientsBrands = [];
    if(stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients;
    }

    const payload = {
      warehouseCode: this.form.value.warehouseCode,
      selectedTours: selectedTours,                 
      selectedCarrier: selectedCarrier,             
      extra: !!this.form.value.extra,
      loadingListPlateNo: (this.form.value.plate ?? '').toString().toUpperCase(),
      loadingListType: this.loadingListType,
      clientsBrands: this.clientsBrands
    };

    this.dialogRef.close(payload);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  get canEditLink(): boolean {
    return this.mode === 'CREATE' && !this.readOnly;
  }

  get readyToLinkTrip(): boolean {
    const warehouseOk = !!this.form?.get('warehouseCode')?.value;
    const tourGroupOk = this.getSelectedTourGroupIds().length > 0;
    const carrierOk = !!this.form?.get('carrierCode')?.value;
    return warehouseOk && tourGroupOk && carrierOk;
  }

  openLinkInput(): void {
    if (!this.canEditLink || !this.readyToLinkTrip) return;

    if (!this.linkCodeValue && this.data?.linkedTripCode) {
      this.linkCodeValue = this.data.linkedTripCode;
    }
    this.linkResolveError = null;
    this.linkMode = 'INPUT';
  }

  confirmLink(): void {
    const value = (this.linkCodeValue || '').trim();
    if (!value || this.resolvingLink) return;

    this.resolvingLink = true;
    this.linkResolveError = null;

    const request: TripAttachRequest = {
      scannedCode: value,
      warehouseCode: this.form?.get('warehouseCode')?.value || this.data.myWarehouseCode || null,
      loadingListId: this.editingLoadingListId
    };

    this.tripService.resolveTripLink(request).subscribe({
      next: (info: TripInfoResponse) => {
        this.resolvingLink = false;

        const currentCarrierCode = this.form.get('carrierCode')?.value || null;

        if (info.tripCarrierCode && currentCarrierCode && info.tripCarrierCode !== currentCarrierCode) {
          this.pendingTripLink = info;
          return;
        }

        this.applyResolvedTripLink(info);
      },
      error: (err) => {
        this.resolvingLink = false;
        this.linkResolveError = err?.error?.message
          || 'Codice non valido: nessun viaggio o documento di trasporto trovato.';
      }
    });
  }

  private applyResolvedTripLink(info: TripInfoResponse, forced: boolean = false): void {
    this.linkMode = 'ACTIVE';
    this.linkCodeValue = info.tripCode;
    this.linkedTripId = info.tripId;
    this.linkedTripCode = info.tripCode;
    this.linkedTripCarrierCode = info.tripCarrierCode ?? null;
    this.linkedTripCarrierName = info.tripCarrierName ?? null;

    if (forced) {
      this.applyForcedTripCarrier();
    } else {
      this.applyCarrierSelection(!!this.form.get('extra')?.value);
    }
  }

  private resolvePrefilledTripLink(code: string): void {
    const request: TripAttachRequest = {
      scannedCode: code,
      warehouseCode: this.form?.get('warehouseCode')?.value || this.data.myWarehouseCode || null,
      loadingListId: null
    };

    this.tripService.resolveTripLink(request).subscribe({
      next: (info: TripInfoResponse) => {
        this.linkedTripId = info.tripId;
        this.linkedTripCode = info.tripCode;
        this.linkCodeValue = info.tripCode;
        this.linkedTripCarrierCode = info.tripCarrierCode ?? null;
        this.linkedTripCarrierName = info.tripCarrierName ?? null;

        if (this.form?.get('carrierCode')?.value) {
          this.applyCarrierSelection(!!this.form.get('extra')?.value);
        }
      },
      error: () => {
        this.linkMode = 'NONE';
        this.linkFromTrip = false;
        this.linkedTripId = null;
        this.linkedTripCode = null;
        this.linkCodeValue = '';
      }
    });
  }

  private applyForcedTripCarrier(): void {
    if (!this.linkedTripCarrierCode) return;

    this.linkedTripCarrierMismatch = false;
    this.carriers = [{
      carrierCode: this.linkedTripCarrierCode,
      carrierName: this.linkedTripCarrierName || this.linkedTripCarrierCode,
      defaultCarrier: false
    } as CarrierResponse];
    this.form.get('carrierCode')?.setValue(this.linkedTripCarrierCode);
  }

  get pendingTripLinkCarrierName(): string {
    if (!this.pendingTripLink) return '';
    return this.pendingTripLink.tripCarrierName || this.pendingTripLink.tripCarrierCode || '-';
  }

  get pendingTripLinkCurrentCarrierName(): string {
    const code = this.form?.get('carrierCode')?.value;
    if (!code) return '-';
    return this.carriers.find(c => c.carrierCode === code)?.carrierName || code;
  }

  confirmForceTripLink(): void {
    if (!this.pendingTripLink) return;
    this.tripLinkForced = true;
    this.applyResolvedTripLink(this.pendingTripLink, true);
    this.pendingTripLink = null;
  }

  cancelForceTripLink(): void {
    this.pendingTripLink = null;
  }

  cancelLinkInput(): void {
    this.linkResolveError = null;
    this.pendingTripLink = null;
    this.linkMode = 'NONE';
  }

  removeLink(): void {
    if (!this.canEditLink) return;

    this.linkMode = 'NONE';
    this.linkCodeValue = '';
    this.linkFromTrip = false;
    this.linkResolveError = null;
    this.pendingTripLink = null;
    this.tripLinkForced = false;
    this.carrierMismatchNeedsDecision = false;

    this.linkedTripId = null;
    this.linkedTripCode = null;
    this.linkedTripCarrierCode = null;
    this.linkedTripCarrierName = null;
    this.linkedTripCarrierMismatch = false;

    this.refreshCarriersFromSelectedGroups();
  }

  hasAnyTourLeft(): boolean {
    const selected = this.getSelectedTourGroupIds();
    return this.tourGroups.some(t => !selected.includes(t.tourRoutingGroupId));
}

    canAddMoreTours(index: number): boolean {
        const wh = this.form.get('warehouseCode')?.value;
        return !!wh && index === this.tourGroupIdsArray.length - 1 && this.hasAnyTourLeft();
    }

    private onExtraChanged(): void {
        this.resetCarrierAndCarriersList();

        this.refreshCarriersFromSelectedGroups();
    }


    step: 1 | 2 = 1;

/** Ricerca case-insensitive su nome e codice, ignorando accenti. */
private normalizeSearch(v: any): string {
  return (v ?? '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

searchCarrierFn = (term: string, item: any): boolean => {
  const t = this.normalizeSearch(term);
  return this.normalizeSearch(item?.carrierName).includes(t);
};

searchWarehouseFn = (term: string, item: any): boolean => {
  const t = this.normalizeSearch(term);
  return this.normalizeSearch(item?.warehouseName).includes(t) || this.normalizeSearch(item?.warehouseShortName).includes(t);
};

get isSingleWarehouse(): boolean {
  return (this.data?.warehouses?.length || 0) === 1;
}

validItems: UiValidItem[] = [];
loadingItems = false;

private buildBaseRequest(): LoadingListManagementRequest | null {
  if (this.form.invalid) {
    this.form.markAllAsTouched();
    return null;
  }

  const selectedTours = this.buildSelectedToursRequest();
  const selectedCarrier = this.buildSelectedCarrierRequest();
  if (!selectedCarrier) {
    this.form.get('carrierCode')?.setErrors({ required: true });
    return null;
  }

  return {
    warehouseCode: this.form.value.warehouseCode,
    selectedTours,
    selectedCarrier,
    extra: !!this.form.value.extra,
    loadingListPlateNo: (this.form.value.plate ?? '').toString().toUpperCase(),
    loadingListType: this.loadingListType
  };
}

backToForm(): void {
  this.step = 1;
}


confirmCreate(): void {
  const base = this.buildBaseRequest();
  if (!base) return;

  if (this.selectedCount === 0) return;

  const stored = localStorage.getItem('userFunctions');
  this.clientsBrands = [];
  if(stored) {
    const parsed = JSON.parse(stored);
    this.clientsBrands = parsed.clients;
  }


  const payload: LoadingListRequest = {
    ...base,
    items: this.buildItemsRequest(),
    clients: this.clientsBrands,
    linkedTripCode: this.linkMode === 'ACTIVE' ? this.linkCodeValue : null
  } as LoadingListRequest & { linkedTripCode: string | null };

  this.dialogRef.close(payload);
}

private toNumber(v: any): number {
  if (v === null || v === undefined) return 0;

  if (typeof v === 'string') {
    const cleaned = v.replace(',', '.').trim();
    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
  }

  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;

  if (typeof v === 'object' && 'value' in v) return this.toNumber((v as any).value);

  return 0;
}


goToItemsStep(): void {
  const req = this.buildBaseRequest();
  if (!req) return;

  this.loadingItems = true;
  this.loadingItemsSpinner = true;

  this.loadingListService.getValidLoadingListItems(req).subscribe({
    next: (res) => {
      const items = res?.loadingListItems ?? [];

      this.validItems = items.map((it, index) => ({
        ...it,
        selected: true,
        weightKgNum: this.toNumber(it.weightKg),
        volumeM3Num: this.toNumber(it.volumeM3),
        loadingListItemStatus: 'LOADED',
        originalIndex: index
      }));

      this.visibleItems = [...this.validItems];
      this.sortVisibleItems();
      this.filteredItemsCount = this.visibleItems.length;

      this.step = 2;
    },
    error: (err) => {
      console.error('getValidLoadingListItems error', err);
      this.validItems = [];
    },
    complete: () => {
      this.loadingItems = false;
      this.loadingItemsSpinner = false;
    }
  });
}

toggleItem(it: any): void {
  it.selected = !it.selected;

  if (it.selected) {
    it.loadingListItemStatus = this.selectedStatusForType();
  } else {
    it.loadingListItemStatus = this.unselectedStatusForType();
  }

  this.sortVisibleItems();

}


selectAll(): void {
  const st = this.selectedStatusForType();

  this.visibleItems.forEach((it: UiValidItem) => {
    it.selected = true;
    it.loadingListItemStatus = st;
  });

  this.sortVisibleItems();
}

deselectAll(): void {
  const st = this.unselectedStatusForType();

  this.visibleItems.forEach((it: UiValidItem) => {
    it.selected = false;
    it.loadingListItemStatus = st;
  });

  this.sortVisibleItems();
}


private buildItemsRequest() {
  return this.validItems.map(i => ({
    loadingListItemParcelComplementaryId: i.loadingListItemParcelComplementaryId,
    loadingListItemParcelId: i.loadingListItemParcelId,
    loadingListItemStatus: i.loadingListItemStatus, 
    loadingListItemCreatedBy: 'ATLAS',
    loadingListItemBarcode: i.barcode
  }));
}

get selectedCount(): number {
  return this.validItems.filter(i => i.selected).length;
}

get totalCount(): number {
  return this.validItems.length;
}

get withoutManifestCount(): number {
  return this.validItems.filter(i => i.parcelWithoutManifest).length;
}

get totalSelectedWeightKg(): number {
  return this.validItems.filter(i => i.selected).reduce((sum, i) => sum + i.weightKgNum, 0);
}

get totalSelectedVolumeM3(): number {
  return this.validItems.filter(i => i.selected).reduce((sum, i) => sum + i.volumeM3Num, 0);
}

get totalAllWeightKg(): number {
  return this.validItems.reduce((sum, i) => sum + i.weightKgNum, 0);
}

get totalAllVolumeM3(): number {
  return this.validItems.reduce((sum, i) => sum + i.volumeM3Num, 0);
}

get weightPct(): number {
  const all = this.totalAllWeightKg;
  return all > 0 ? Math.round((this.totalSelectedWeightKg / all) * 100) : 0;
}

get volumePct(): number {
  const all = this.totalAllVolumeM3;
  return all > 0 ? Math.round((this.totalSelectedVolumeM3 / all) * 100) : 0;
}

get warehouseName(): string {
  const code = this.form.get('warehouseCode')?.value;
  return this.data.warehouses.find(w => w.warehouseCode === code)?.warehouseName ?? '';
}

get carrierName(): string {
  const code = this.form.get('carrierCode')?.value;
  return this.carriers && this.carriers.length > 0 ? this.carriers.find(c => c.carrierCode === code)?.carrierName! : this.data.carriers.find(c => c.carrierCode === code)?.carrierName!;
}

getWarehouseNameArrivalByCode(code: string | null | undefined): string {
  if (!code) return '';
  return this.data?.warehouses?.find(w => w.warehouseCode === code)?.warehouseName ?? '';
}




saveBordero(isUnloadingClosure: boolean = false): void {
  const status =
    this.loadingListType === 'ARRIVAL'
      ? (isUnloadingClosure ? 'CLOSED' : 'ARRIVED')
      : 'PREPARED';

  const stored = localStorage.getItem('userFunctions');
  this.clientsBrands = [];
  if(stored) {
    const parsed = JSON.parse(stored);
    this.clientsBrands = parsed.clients;
  }

  const req = {
    loadingListId: this.data.loadingList.loadingListId,
    loadingListStatus: status,
    loadingListType: this.loadingListType,
    unloadingClosure: isUnloadingClosure,
    loadingListItems: (this.validItems ?? []).map(it => ({
      loadingListItemParcelComplementaryId: it.loadingListItemParcelComplementaryId,
      loadingListItemParcelId: it.loadingListItemParcelId,
      loadingListItemStatus: !isUnloadingClosure && it.loadingListItemStatus == 'UNLOADED' ? 'ARRIVED' : it.loadingListItemStatus,
      loadingListItemCreatedBy: '', 
      loadingListItemBarcode: it.barcode
    })),
    clients: this.clientsBrands
  } as LoadingListItemsRequest;
  this.dialogRef.close(req);
}


private selectedStatusForType(): LoadingListItemStatus {
  return this.loadingListType === 'DEPARTURE' ? 'LOADED' : 'UNLOADED';
}

isDepartureNotLoaded(it: UiValidItem): boolean {
  return !it.selected && (this.loadingListStatus === 'CLOSED' || it.loadingListItemStatus === 'NOT_LOADED');
}

private unselectedStatusForType(): LoadingListItemStatus {
  if(this.loadingListType === 'DEPARTURE' && this.loadingListStatus === 'CLOSED') {
    return 'NOT_LOADED';
  }
  return this.loadingListType === 'DEPARTURE' ? 'PENDING' : 'LOADED';
}

// setType(type: 'DEPARTURE' | 'ARRIVAL') {

//   if (type === 'DEPARTURE' && this.isArrivedStatus(this.data?.loadingList?.loadingListStatus)) {
//     return;
//   }

//   this.loadingListType = type;

//   const selStatus = this.selectedStatusForType();

//   this.validItems = (this.validItems ?? []).map(it => ({
//     ...it,
//     selected: it.loadingListItemStatus === selStatus
//   }));

// }

private setSingleTourGroupIfNeeded(): void {
  const fa = this.tourGroupIdsArray; 
  if (!fa || fa.length === 0) return;

  const firstCtrl = fa.at(0) as FormControl<number | null>;
  const alreadySet = firstCtrl.value != null;

  if (!alreadySet && (this.tourGroups?.length ?? 0) === 1) {
    firstCtrl.setValue(this.tourGroups[0].tourRoutingGroupId, { emitEvent: true });
  }
}

private setSingleCarrierIfNeeded(): void {
  const carrierCtrl = this.form.get('carrierCode') as FormControl<string | null>;
  if (!carrierCtrl) return;

  if (carrierCtrl.value) return;

  if ((this.carriers?.length ?? 0) === 1) {
    carrierCtrl.setValue(this.carriers[0].carrierCode, { emitEvent: false });
  }
}

// isArrivedStatus(status: any): boolean {
//   const s = (status ?? '').toString().toUpperCase();
//   return s === 'ARRIVED' || s === 'ARRIVATO';
// }

private loadPossibleWarehouses(loadingListId: number): void {
  this.loadingListService.getPossibleWarehouses(loadingListId).subscribe({
    next: (whs) => {
      this.possibleWarehouses = whs ?? [];

      if (this.possibleWarehouses.length === 1) {
        this.selectedWarehouseCode = this.possibleWarehouses[0];
      } else {
        if (this.selectedWarehouseCode && !this.possibleWarehouses.includes(this.selectedWarehouseCode)) {
          this.selectedWarehouseCode = null;
        }
      }

      this.tryReloadItems();
    },
    error: (err) => console.error(err)
  });
}

private tryReloadItems(): void {
  if (!this.editingLoadingListId) return;
  if (!this.loadingListType) return;
  if (!this.selectedWarehouseCode && this.loadingListType == 'ARRIVAL') return;
  // if (this.loadingListType == 'DEPARTURE') this.selectedWarehouseCode = null ;

  this.loadingItemsSpinner = true;

  this.loadingListService
    .getLoadingListItems(this.editingLoadingListId, this.selectedWarehouseCode!, this.loadingListType)
    .pipe(finalize(() => (this.loadingItemsSpinner = false)))
    .subscribe({
      next: (items) => {
        const selStatus = this.selectedStatusForType();

        this.validItems = (items ?? []).map((x: any, index: number) => {

          var status: LoadingListItemStatus = x.loadingListItemStatus;
          if(!status) status = 'PENDING';
          else if(status === 'ARRIVED') status = 'UNLOADED';

          return {
            ...x,
            selected: status === selStatus || (this.loadingListType == 'DEPARTURE' &&  this.llStatus === 'CLOSED' && status != 'NOT_LOADED' && x.loadedDate != null),
            weightKgNum: Number(x.weightKg ?? 0),
            volumeM3Num: Number(x.volumeM3 ?? 0),
            loadingListItemStatus: status,
            originalIndex: index
          };
        });

        this.applyFilters();
        this.availableRegions = Array.from(
          new Set(this.validItems.map(i => i.regionAcronym).filter(Boolean))
        );
      },
      error: (err) => console.error(err)
    });
}

onLoadingListTypeChange(newType: LoadingListType): void {
  this.loadingListType = newType;
  this.tryReloadItems();
}

onWarehouseChange(newWarehouse: string): void {
  this.selectedWarehouseCode = newWarehouse;
  this.tryReloadItems();
}

  get canEdit(): boolean {
    if (this.readOnly) return false;

    if(this.mode == 'CREATE') return true;

    if (this.loadingListType === 'DEPARTURE') {
      return this.isDraft() || this.isPrepared();
    }

    if (this.isDraft()) return false;
    if (this.isClosed()) return false;
    return this.isPrepared() || this.isArrived();
  }

  get canToggleItems(): boolean {
    return this.canEdit && !this.isDeclaringUnloadingEnd;
  }

  get canSave(): boolean {
    return this.canEdit;
  }

getArrivalStatusLabel(it: UiValidItem): string {
  if (this.isDeclaringUnloadingEnd || it.loadingListItemStatus == 'NOT_ARRIVED' || this.loadingListStatus === 'CLOSED') {
    return it.selected ? 'SCARICATO' : 'NON ARRIVATO';
  }

  return it.selected ? 'ARRIVATO' : 'IN ARRIVO';
}

getArrivalStatusClass(it: UiValidItem): 'validated' | 'pending' | 'not-arrived' | 'not-loaded' {
  if (this.isDeclaringUnloadingEnd || it.loadingListItemStatus == 'NOT_ARRIVED' ) {
    return it.selected ? 'validated' : 'not-arrived';
  }
  if(this.loadingListStatus === 'CLOSED') {
    return it.selected ? 'validated' : 'not-loaded';
  }
  return it.selected ? 'validated' : 'pending';
}

getItemLoadedAt(it: any): string | null {
  if (!this.showAllItemDates && this.loadingListType !== 'DEPARTURE') return null;
  if (!it?.loadedDate) return null;
  if (it.loadingListItemStatus === 'NOT_LOADED') return null;
  if (this.loadingListType === 'DEPARTURE' && !it.selected) return null;
  return it.loadedDate;
}

getItemArrivedAt(it: any): string | null {
  if (!this.showAllItemDates && this.loadingListType !== 'ARRIVAL') return null;
  const d = it?.arrivedDate ?? it?.unloadedDate;
  if (!d) return null;
  if (it.loadingListItemStatus === 'NOT_ARRIVED') return null;
  if (this.loadingListType === 'ARRIVAL' && !it.selected) return null;
  return d;
}

declareUnloadingEnd(): void {
  if (this.mode !== 'EDIT' || this.loadingListType !== 'ARRIVAL') return;
  if (!this.canSave) return;

  this.itemsSnapshot = (this.validItems ?? []).map(it => ({
    selected: !!it.selected,
    status: it.loadingListItemStatus
  }));

  this.isDeclaringUnloadingEnd = true;

  this.validItems.forEach(it => {
    if (it.selected) {
      it.loadingListItemStatus = 'UNLOADED';
    } else {
      it.loadingListItemStatus = 'NOT_ARRIVED' as any;
    }
  });
}

cancelDeclareUnloadingEnd(): void {
  if (!this.isDeclaringUnloadingEnd) return;

  this.validItems.forEach((it, idx) => {
    const snap = this.itemsSnapshot[idx];
    if (!snap) return;
    it.selected = snap.selected;
    it.loadingListItemStatus = snap.status;
  });

  this.isDeclaringUnloadingEnd = false;
  this.itemsSnapshot = [];
}

confirmDeclareUnloadingEnd(): void {
  if (!this.isDeclaringUnloadingEnd) return;

  // boolean `closeUnloading` 
  this.saveBordero(true);
}


// --- Search barcode ---
barcodeFilter = '';
private barcodeFilterTimer: any = null;

filteredItemsCount = 0;

// Se hai già validItems come array "source", qui mettiamo i risultati filtrati
visibleItems: any[] = []; // oppure tipizza il tuo item

onBarcodeFilterChange(value: string) {
  this.barcodeFilter = value;

  // debounce 350ms (puoi mettere 500 se lo vuoi più “calmo”)
  if (this.barcodeFilterTimer) {
    clearTimeout(this.barcodeFilterTimer);
  }

  this.barcodeFilterTimer = setTimeout(() => {
    this.applyBarcodeFilter();
  }, 350);
}

clearBarcodeFilter() {
  this.barcodeFilter = '';
  this.applyBarcodeFilter();
}

private applyBarcodeFilter() {
  // Barcode, urgenti e aggiunti in arrivo si combinano: un unico punto di filtro
  this.applyFilters();
}

  private sortVisibleItems(): void {
    this.visibleItems = [...this.visibleItems].sort((a, b) => {

      // 1. NON selezionati sopra
      if (a.selected !== b.selected) {
        return a.selected ? 1 : -1;
      }

      // 2. Data affido DESC
      const dateA = a.parcelDate ? new Date(a.parcelDate).getTime() : 0;
      const dateB = b.parcelDate ? new Date(b.parcelDate).getTime() : 0;

      if (dateA !== dateB) {
        return dateB - dateA;
      }

      // 3. Urgenti prima
      const urgentA = !!a.urgencyCode;
      const urgentB = !!b.urgencyCode;

      if (urgentA !== urgentB) {
        return urgentA ? -1 : 1;
      }

      // 4. Ordine originale
      return a.originalIndex - b.originalIndex;
    });
  }

  // --- Colli aggiunti in arrivo (LOADING_LIST_ITEM_IS_LOADED_ON_DEPARTURE = 'N') ---

  /**
   * Evidenziazione e filtro visibili in modifica sul borderò in arrivo, oppure per chi vede
   * tutte le date (utente multi-magazzino / viaggi esterni da Gestione viaggi).
   */
  get showAddedOnArrival(): boolean {
    return (
      this.mode === 'EDIT' &&
      (this.loadingListType === 'ARRIVAL' || !!this.data?.showAllItemDates)
    );
  }

  isAddedOnArrival(it: UiValidItem | any): boolean {
    return this.showAddedOnArrival && !!it?.addedOnArrival;
  }

  get addedOnArrivalCount(): number {
    if (!this.showAddedOnArrival) return 0;
    return (this.validItems ?? []).filter(it => !!it.addedOnArrival).length;
  }

  // --- Bolla inviata al vettore (visibile su tutti i borderò, partenza e arrivo) ---

  /** Invio bolle visibile solo su un borderò esistente (in creazione i colli non hanno questo dato). */
  get showWaybillSent(): boolean {
    return this.mode === 'EDIT';
  }

  isWaybillSent(it: UiValidItem | any): boolean {
    return this.showWaybillSent && !!it?.waybillSentToCarrier;
  }

  /** Collo con bolla (affidato) la cui bolla non e' ancora stata inviata al vettore. */
  isWaybillNotSent(it: UiValidItem | any): boolean {
    return this.showWaybillSent && !!it && !it.parcelWithoutManifest && !it.waybillSentToCarrier;
  }

  get waybillNotSentCount(): number {
    return (this.validItems ?? []).filter(it => this.isWaybillNotSent(it)).length;
  }

  getWaybillNotSentTooltip(it: UiValidItem | any): string {
    return it?.waybillCode
      ? `Bolla ${it.waybillCode} non ancora inviata al vettore`
      : 'Bolla non ancora inviata al vettore';
  }

  toggleWaybillNotSentFilter(): void {
    this.onlyWaybillNotSent = !this.onlyWaybillNotSent;
    this.applyFilters();
  }

  getWaybillSentTooltip(it: UiValidItem | any): string {
    if (!this.isWaybillSent(it)) return '';
    const parts: string[] = [
      it.waybillCode ? `Bolla ${it.waybillCode} inviata al vettore` : 'Bolla inviata al vettore'
    ];
    if (it.waybillCarriersSentAt) {
      const d = new Date(it.waybillCarriersSentAt);
      if (!isNaN(d.getTime())) {
        const pad = (n: number) => String(n).padStart(2, '0');
        parts[0] += ` il ${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      }
    }
    // const emails = (it.waybillCarriersSentEmails || '')
    //   .split(';')
    //   .map((e: string) => e.trim())
    //   .filter((e: string) => e.length > 0);
    // if (emails.length) {
    //   parts.push(`Destinatari: ${emails.join(', ')}`);
    // }
    return parts.join('\n');
  }

  toggleAddedOnArrivalFilter(): void {
    this.onlyAddedOnArrival = !this.onlyAddedOnArrival;
    this.applyFilters();
  }

  /** Magazzino di arrivo del collo: quello del borderò in arrivo, altrimenti quello del collo. */
  private getItemArrivalWarehouseCode(it: UiValidItem | any): string | null {
    if (this.loadingListType === 'ARRIVAL' && this.selectedWarehouseCode) {
      return this.selectedWarehouseCode;
    }
    return it?.warehouseToCode || this.selectedWarehouseCode || null;
  }

  /**
   * Apre "Gestione Colli TP" in una nuova scheda, gia' filtrata per magazzino di arrivo e codice
   * collo (il borderò resta aperto).
   */
  openParcelInOverview(it: UiValidItem | any, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();

    const queryParams: Record<string, string> = {};
    const warehouseCode = this.getItemArrivalWarehouseCode(it);
    const parcelCode = it?.parcelCode || it?.barcode;
    if (warehouseCode) queryParams['warehouseCode'] = warehouseCode;
    if (parcelCode) queryParams['parcelCode'] = parcelCode;

    const tree = this.router.createUrlTree([OVERVIEW_WAREHOUSE_ROUTE], { queryParams });
    // prepareExternalUrl gestisce base href e HashLocationStrategy
    const url = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(tree));
    window.open(url, '_blank', 'noopener');
  }

  toggleUrgencyFilter() {
    this.onlyUrgent = !this.onlyUrgent;
    this.applyFilters();
  }

  public applyFilters() {
    const term = (this.barcodeFilter || '').trim().toLowerCase();

    this.visibleItems = this.validItems.filter(it => {

      // BARCODE
      if (term && !(it.barcode || '').toString().toLowerCase().includes(term)) {
        return false;
      }

      // URGENZA
      if (this.onlyUrgent && !it.urgencyCode) {
        return false;
      }

      // AGGIUNTI IN ARRIVO
      if (this.onlyAddedOnArrival && !this.isAddedOnArrival(it)) {
        return false;
      }

      // BOLLA NON INVIATA AL VETTORE
      if (this.onlyWaybillNotSent && !this.isWaybillNotSent(it)) {
        return false;
      }

      return true;
    });

    this.sortVisibleItems();
    this.filteredItemsCount = this.visibleItems.length;
  }

  // ===========================================================================================
  // IMPORT EXCEL DI BARCODE (solo borderò di partenza modificabili)
  // I colli scelti vengono aggiunti solo in interfaccia: il salvataggio vero e' "Salva/Crea Borderò".
  // ===========================================================================================

  importView: 'NONE' | 'INTRO' | 'LOADING' | 'PREVIEW' = 'NONE';
  importFileName = '';
  importRows: ImportPreviewRow[] = [];
  importError = '';
  importDuplicatesCount = 0;
  importEmptyRowsCount = 0;
  importAddedCount = 0;
  importOnlyIssues = false;

  get canImportExcel(): boolean {
    return this.step === 2
      && this.canEdit
      && this.loadingListType === 'DEPARTURE'
      && !this.isDeclaringUnloadingEnd
      && !this.loadingItemsSpinner;
  }

  /** Apre la schermata di import: esempio da scaricare + bottone Importa. */
  openImportIntro(): void {
    this.importError = '';
    this.importRows = [];
    this.importView = 'INTRO';
  }

  /** Scarica l'Excel di esempio: sola colonna "Barcode". */
  downloadImportTemplate(): void {
    const ws = XLSX.utils.aoa_to_sheet([['Barcode']]);
    ws['!cols'] = [{ wch: 28 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Barcode');
    XLSX.writeFile(wb, 'Esempio_import_bordero.xlsx');
  }

  onImportFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = ''; // permette di reimportare lo stesso file
    if (!file) return;

    this.importFileName = file.name;
    this.importError = '';
    this.importRows = [];
    this.importOnlyIssues = false;
    this.importView = 'LOADING';
    const startedAt = Date.now();

    const reader = new FileReader();
    reader.onerror = () => this.failImport('Impossibile leggere il file selezionato.');
    reader.onload = () => {
      let barcodes: string[];
      try {
        barcodes = this.readBarcodesFromWorkbook(reader.result as ArrayBuffer);
      } catch (e) {
        console.error('Import Excel: errore lettura', e);
        this.failImport('Il file non è un Excel valido.');
        return;
      }

      if (!barcodes.length) {
        this.failImport('Nessun barcode trovato: compila la colonna "Barcode" (una riga per collo).');
        return;
      }
      if (barcodes.length > IMPORT_MAX_BARCODES) {
        this.failImport(`Troppi barcode (${barcodes.length}): massimo ${IMPORT_MAX_BARCODES} per import.`);
        return;
      }

      this.http
        .post<ImportBarcodeRowResponse[]>(`${environment.apiUrl}/loading-list/importBarcodesPreview`, {
          loadingListId: this.mode === 'EDIT' ? (this.data?.loadingList?.loadingListId ?? null) : null,
          warehouseCode: this.getImportWarehouseCode(),
          tourRoutingGroupIds: this.mode === 'CREATE' ? this.getSelectedTourGroupIds() : [],
          barcodes
        })
        .subscribe({
          next: (res) => {
            // Lascio visibile l'animazione almeno per un attimo
            const wait = Math.max(0, IMPORT_MIN_LOADING_MS - (Date.now() - startedAt));
            setTimeout(() => {
              this.importRows = (res ?? []).map(r => this.toImportPreviewRow(r));
              this.importView = 'PREVIEW';
            }, wait);
          },
          error: (err) => {
            console.error('Import Excel: errore anteprima', err);
            this.failImport(err?.error?.message || 'Errore durante la verifica dei barcode.');
          }
        });
    };
    reader.readAsArrayBuffer(file);
  }

  private failImport(message: string): void {
    this.importError = message;
    this.importView = 'PREVIEW';
    this.importRows = [];
  }

  private getImportWarehouseCode(): string | null {
    if (this.mode === 'EDIT') {
      return this.data?.loadingList?.loadingListWarehouseCode ?? this.form?.get('warehouseCode')?.value ?? null;
    }
    return this.form?.get('warehouseCode')?.value ?? null;
  }

  /**
   * Legge la colonna "Barcode" del primo foglio (se manca l'intestazione usa la prima colonna).
   * Scarta righe vuote e duplicati, contandoli per il riepilogo.
   */
  private readBarcodesFromWorkbook(buffer: ArrayBuffer): string[] {
    const wb = XLSX.read(buffer, { type: 'array' });
    const sheet = wb.Sheets[wb.SheetNames[0]];
    if (!sheet) return [];

    const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' });
    if (!rows.length) return [];

    const header = (rows[0] ?? []).map(c => (c ?? '').toString().trim().toLowerCase());
    let col = header.findIndex(h => h === 'barcode');
    let start = 1;
    if (col < 0) {
      col = 0;
      start = 0; // nessuna intestazione: ogni riga e' un barcode
    }

    const seen = new Set<string>();
    const barcodes: string[] = [];
    this.importDuplicatesCount = 0;
    this.importEmptyRowsCount = 0;

    for (let i = start; i < rows.length; i++) {
      const value = (rows[i]?.[col] ?? '').toString().trim();
      if (!value) {
        this.importEmptyRowsCount++;
        continue;
      }
      if (seen.has(value)) {
        this.importDuplicatesCount++;
        continue;
      }
      seen.add(value);
      barcodes.push(value);
    }
    return barcodes;
  }

  private toImportPreviewRow(r: ImportBarcodeRowResponse): ImportPreviewRow {
    const checks = r.checks ?? [];
    const existing = (this.validItems ?? []).find(it => (it.barcode || '').toUpperCase() === (r.barcode || '').toUpperCase());
    const alreadyInList = !!existing || checks.includes('ALREADY_IN_LOADING_LIST');
    const departed = checks.includes('LOADING_LIST_DEPARTED');

    const messages: ImportMessage[] = [];
    if (alreadyInList) {
      messages.push({
        level: 'info',
        text: existing?.selected
          ? 'OK, ma era già presente nel borderò (già selezionato)'
          : 'OK, ma era già presente nel borderò (non selezionato): verrà selezionato'
      });
    }

    for (const check of checks) {
      // Se il collo e' gia' nel borderò in interfaccia, gli errori di disponibilita' non contano
      if (alreadyInList && ['ALREADY_IN_LOADING_LIST', 'NOT_AVAILABLE', 'IN_OTHER_LOADING_LIST', 'LOADED_IN_OTHER_DRAFT', 'IN_OTHER_DRAFT', 'REMOVED_FROM_THIS_LIST'].includes(check)) {
        continue;
      }
      const msg = this.importCheckMessage(check, r);
      if (msg) messages.push(msg);
    }

    let level: 'ok' | 'warning' | 'error';
    if (departed || (!alreadyInList && r.severity === 'ERROR')) {
      level = 'error';
    } else if (messages.some(m => m.level === 'warning')) {
      level = 'warning';
    } else {
      level = 'ok';
    }

    if (level === 'ok' && !alreadyInList) {
      messages.unshift({ level: 'ok', text: 'Collo trovato, pronto per essere aggiunto' });
    }

    const selectable = level !== 'error' && (!!existing || !!r.item);
    return {
      ...r,
      checks,
      level,
      messages,
      selectable,
      selected: selectable,
      alreadyInList
    };
  }

  private importCheckMessage(check: string, r: ImportBarcodeRowResponse): ImportMessage | null {
    switch (check) {
      case 'NOT_FOUND':
        return { level: 'error', text: 'Collo non trovato in partenza da questo magazzino' };
      case 'NOT_AVAILABLE':
        return { level: 'error', text: 'Collo non disponibile (già in viaggio o chiuso)' };
      case 'IN_OTHER_LOADING_LIST':
        return { level: 'error', text: `Collo già presente nel borderò ${r.otherLoadingListCode ?? ''}`.trim() };
      case 'LOADED_IN_OTHER_DRAFT':
        return { level: 'error', text: `Collo già caricato nella bozza ${r.otherLoadingListCode ?? ''}`.trim() };
      case 'LOADING_LIST_DEPARTED':
        return { level: 'error', text: 'Borderò già partito: non si possono aggiungere colli' };
      case 'MISROUTING':
        return {
          level: 'warning',
          text: `Possibile misrouting: gruppo tour del collo${r.parcelTourGroupNames ? ' (' + r.parcelTourGroupNames + ')' : ''} diverso da quelli del borderò`
        };
      case 'NO_TOUR_GROUP':
        return { level: 'warning', text: 'Collo senza gruppo tour su questo magazzino' };
      case 'IN_OTHER_DRAFT':
        return { level: 'warning', text: `Presente nella bozza ${r.otherLoadingListCode ?? ''}: verrà tolto dalla bozza`.replace(/\s+:/, ':') };
      case 'ON_OTHER_TRIP':
        return { level: 'warning', text: `Collo sul viaggio ${r.otherTripCode ?? ''}: verrà spostato sul viaggio di questo borderò` };
      case 'NOT_ARRIVED_IN_WAREHOUSE':
        return { level: 'warning', text: 'Il collo non risulta ancora arrivato in questo magazzino' };
      case 'REMOVED_FROM_THIS_LIST':
        return { level: 'warning', text: 'Il collo era stato tolto da questo borderò' };
      default:
        return null;
    }
  }

  // --- riepilogo / selezione anteprima ---

  get importVisibleRows(): ImportPreviewRow[] {
    return this.importOnlyIssues
      ? this.importRows.filter(r => r.level !== 'ok')
      : this.importRows;
  }

  get importTotalCount(): number { return this.importRows.length; }
  get importFoundCount(): number { return this.importRows.filter(r => !!r.item || r.alreadyInList).length; }
  get importOkCount(): number { return this.importRows.filter(r => r.level === 'ok').length; }
  get importWarningCount(): number { return this.importRows.filter(r => r.level === 'warning').length; }
  get importErrorCount(): number { return this.importRows.filter(r => r.level === 'error').length; }
  get importAlreadyCount(): number { return this.importRows.filter(r => r.alreadyInList).length; }
  /** Gia' presenti che rientrano negli OK (mostrati dentro il badge verde). */
  get importAlreadyOkCount(): number { return this.importRows.filter(r => r.alreadyInList && r.level === 'ok').length; }
  get importSelectedCount(): number { return this.importRows.filter(r => r.selected).length; }

  get importSelectedWeightKg(): number {
    return this.importRows
      .filter(r => r.selected)
      .reduce((sum, r) => sum + this.toNumber(r.item?.weightKg), 0);
  }

  toggleImportRow(row: ImportPreviewRow): void {
    if (!row.selectable) return;
    row.selected = !row.selected;
  }

  selectAllImportRows(): void {
    this.importVisibleRows.forEach(r => { if (r.selectable) r.selected = true; });
  }

  deselectAllImportRows(): void {
    this.importVisibleRows.forEach(r => (r.selected = false));
  }

  cancelImport(): void {
    this.importView = 'NONE';
    this.importRows = [];
    this.importError = '';
  }

  /** Aggiunge i colli selezionati al borderò (solo interfaccia). */
  addImportedItems(): void {
    const status = this.selectedStatusForType();
    let added = 0;

    for (const row of this.importRows.filter(r => r.selected && r.selectable)) {
      const existing = this.validItems.find(it => (it.barcode || '').toUpperCase() === (row.barcode || '').toUpperCase());
      if (existing) {
        if (!existing.selected) {
          existing.selected = true;
          existing.loadingListItemStatus = status;
          added++;
        }
        continue;
      }
      if (!row.item) continue;

      this.validItems.push({
        ...(row.item as LoadingListItemsResponse),
        selected: true,
        loadingListItemStatus: status,
        weightKgNum: this.toNumber(row.item.weightKg),
        volumeM3Num: this.toNumber(row.item.volumeM3),
        originalIndex: this.validItems.length,
        importedFromExcel: true
      } as UiValidItem);
      added++;
    }

    this.importAddedCount = added;
    this.importView = 'NONE';
    this.importRows = [];
    this.applyFilters();
  }

  dismissImportBanner(): void {
    this.importAddedCount = 0;
  }

  exportToExcel(): void {
    const items = [...(this.visibleItems ?? [])]; // mantiene l'ordine di visualizzazione

    const itemsTotal = [...(this.validItems ?? [])];

    if (!items.length) return;

    const generalData = {
      'Codice Borderò': this.loadingListCode,
      'Tipo Borderò': this.loadingListType === 'DEPARTURE' ? 'Partenza' : 'Arrivo',
      'Modalità': this.mode,
      'Stato Borderò': this.getStatusLabel(),
      'Magazzino Codice': this.loadingListType === 'ARRIVAL'
        ? (this.selectedWarehouseCode ?? '')
        : (this.form.get('warehouseCode')?.value ?? ''),
      'Magazzino Nome': this.loadingListType === 'ARRIVAL'
        ? this.getWarehouseNameArrivalByCode(this.selectedWarehouseCode)
        : this.warehouseName,
      'Tour Group': this.selectedTourGroupNames || this.tourGroupNames || '',
      'Vettore Codice': this.form.get('carrierCode')?.value ?? '',
      'Vettore Nome': this.carrierName ?? '',
      'Targa rimorchio': this.form.get('plate')?.value ?? '',
      'Extra': this.form.get('extra')?.value ? 'SI' : 'NO',
      'Totale Colli': itemsTotal.length,
      'Peso Totale (kg)': itemsTotal.reduce((s, i) => s + (Number(i.weightKgNum) || 0), 0),
      'Volume Totale (m3)': itemsTotal.reduce((s, i) => s + (Number(i.volumeM3Num) || 0), 0),
      'Totale Colli Selezionati': itemsTotal.filter(i => i.selected).length,
      'Peso Selezionato (kg)': itemsTotal.filter(i => i.selected).reduce((s, i) => s + (Number(i.weightKgNum) || 0), 0),
      'Volume Selezionato (m3)': itemsTotal.filter(i => i.selected).reduce((s, i) => s + (Number(i.volumeM3Num) || 0), 0),
      'Totale Colli Visualizzati': items.length,
      'Peso Visualizzato (kg)': items.reduce((s, i) => s + (Number(i.weightKgNum) || 0), 0),
      'Volume Visualizzato (m3)': items.reduce((s, i) => s + (Number(i.volumeM3Num) || 0), 0),
      'Totale Colli Selezionati Visualizzati': items.filter(i => i.selected).length,
      'Peso Selezionato Visualizzato (kg)': items.filter(i => i.selected).reduce((s, i) => s + (Number(i.weightKgNum) || 0), 0),
      'Volume Selezionato Visualizzato (m3)': items.filter(i => i.selected).reduce((s, i) => s + (Number(i.volumeM3Num) || 0), 0),
      'Filtro Barcode': this.barcodeFilter || '',
      ...(this.showWaybillSent
      ? { 'Filtro Bolle Non Inviate': this.onlyWaybillNotSent ? 'SI' : 'NO' }
      : {}),
      ...(this.showAddedOnArrival
      ? { 'Filtro Aggiunti In Arrivo': this.onlyAddedOnArrival ? 'SI' : 'NO' }
      : {}),
      'Filtro Solo Urgenti': this.onlyUrgent ? 'SI' : 'NO',
      'Data Export': new Date()
    };

    const rows = items.map((it, index) => ({
      ...(this.mode === 'EDIT'
      ? { 'Codice Borderò': this.loadingListCode ?? '' }
      : {}),
      'Codice Collo': it.parcelCode ?? '',
      'Barcode': it.barcode ?? '',
      'Peso Kg': it.weightKgNum ?? '',
      'Volume M3': it.volumeM3Num ?? '',
      'Selezionato': it.selected ? 'SI' : 'NO',
      'Stato Riga': it.parcelWithoutManifest
                  ? 'NON AFFIDATO'
                  : this.loadingListType === 'DEPARTURE'
                  ? (it.selected ? 'CARICATO' : this.isDepartureNotLoaded(it) ? 'NON CARICATO' : 'IN SOSPESO')
                  : this.getArrivalStatusLabel(it),
      'Urgente': it.urgencyCode ? 'SI' : 'NO',
      ...(this.showWaybillSent
      ? {
          'Bolla': it.waybillCode ?? '',
          'Bolla Inviata Vettore': this.isWaybillSent(it) ? 'SI' : 'NO',
          'Data Invio Bolla': this.formatDateOnly(it.waybillCarriersSentAt ?? null),
          'Ora Invio Bolla': this.formatTimeOnly(it.waybillCarriersSentAt ?? null)
        }
      : {}),
      ...(this.showAddedOnArrival
      ? { 'Aggiunto in arrivo': this.isAddedOnArrival(it) ? 'SI' : 'NO' }
      : {}),
      'Codice Urgenza': it.urgencyCode ?? '',
      'Tour Group': it.tourRoutingGroupName ?? '',
      'Tipo': it.parcelPalletType ?? '',
      'Data Affido': this.formatDateOnly(it.parcelDate),
      'Ora Data Affido': this.formatTimeOnly(it.parcelDate),
      'Data Consegna Stimata': this.formatDateOnly(it.parcelEstimatedDeliveryDate),
      'Ora Data Consegna Stimata': this.formatTimeOnly(it.parcelEstimatedDeliveryDate),
      'Regione': it.regionAcronym ?? '',
      'Cliente': it.clientAcronym ?? '',
      'Data Carico': this.formatDateOnly(this.getItemLoadedAt(it)),
      'Ora Carico': this.formatTimeOnly(this.getItemLoadedAt(it)),
      'Data Arrivo': this.formatDateOnly(this.getItemArrivedAt(it)),
      'Ora Arrivo': this.formatTimeOnly(this.getItemArrivedAt(it))

      // ID TECNICI
      // 'LoadingListItem Parcel Complementary Id': it.loadingListItemParcelComplementaryId ?? '',
      // 'LoadingListItem Parcel Id': it.loadingListItemParcelId ?? '',
      // 'LoadingListItem Status': it.loadingListItemStatus ?? '',

      // GENERALI
      // 'Codice Borderò': this.loadingListCode,
      // 'Tipo Borderò': this.loadingListType === 'DEPARTURE' ? 'Partenza' : 'Arrivo',
      // 'Modalità': this.mode,
      // 'Stato Borderò': this.getStatusLabel(),
      // 'Magazzino Codice': this.loadingListType === 'ARRIVAL'
      //   ? (this.selectedWarehouseCode ?? '')
      //   : (this.form.get('warehouseCode')?.value ?? ''),
      // 'Magazzino Nome': this.loadingListType === 'ARRIVAL'
      //   ? this.getWarehouseNameArrivalByCode(this.selectedWarehouseCode)
      //   : this.warehouseName,
      // 'Tour Group Selezionati': this.selectedTourGroupNames || this.tourGroupNames || '',
      // 'Vettore Codice': this.form.get('carrierCode')?.value ?? '',
      // 'Vettore Nome': this.carrierName ?? '',
      // 'Targa': this.form.get('plate')?.value ?? '',
      // 'Extra': this.form.get('extra')?.value ? 'SI' : 'NO',
    }));

    const wb = XLSX.utils.book_new();

    // Sheet riepilogo
    const summarySheetData = [
      ['Campo', 'Valore'],
      ...Object.entries(generalData)
    ];
    const wsSummary = XLSX.utils.aoa_to_sheet(summarySheetData);

    // Sheet colli
    const wsItems = XLSX.utils.json_to_sheet(rows);

    // larghezza colonne
    wsSummary['!cols'] = [
      { wch: 30 },
      { wch: 40 }
    ];

    wsItems['!cols'] = Object.keys(rows[0] || {}).map((key) => ({
      wch: Math.max(15, key.length + 2)
    }));

    XLSX.utils.book_append_sheet(wb, wsSummary, 'Riepilogo');
    XLSX.utils.book_append_sheet(wb, wsItems, 'Colli Visualizzati');

    const fileName = `bordero${this.loadingListCode}_${this.loadingListType.toLowerCase()}_${this.formatDateForFile(new Date())}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  private formatDateForFile(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${yyyy}${mm}${dd}${hh}${mi}`;
  }

  private formatDateOnly(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('it-IT'); // 28/03/2026
  }

  private formatTimeOnly(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }); // 14:35
  }

  get showAllItemDates(): boolean {
    return this.data?.showAllItemDates === true;
  }

}